import React, { Component } from 'react';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowRight from '@mui/icons-material/ArrowRight';
import IconButton from '@mui/material/IconButton';

export default class PeriodPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: new Date(),
            end: new Date(),
            currentDate: new Date()
        };

        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.getDates = this.getDates.bind(this);
    }

    getDates(d) {
        if (!d) d = new Date();
        else d = new Date(d);

        var start = this.startOfWeek(d);
        var end = this.endOfWeek(d);
        if (this.props.viewType === -1) {
            start = d;
            end = d;
        }
        if (this.props.viewType === 1) {
            start = this.startOfMonth(d);
            end = this.endOfMonth(d);
        }
        else if (this.props.viewType === 2) {
            start = this.startOfYear(d);
            end = this.endOfYear(d);
        }
        else if (this.props.viewType === 3) {
            start = new Date(1, 1, 1);
            end = new Date();
        }
        return {
            start: start,
            end: end
        };
    }

    componentDidMount() {
        this.setState(this.getDates());
    }

    componentDidUpdate(prevProps) {
        if (prevProps.viewType !== this.props.viewType) {
            this.setState(this.getDates());
        }
    }

    startOfMonth(d) {
        d = new Date(d);
        return new Date(d.getFullYear(), d.getMonth(), 1);
    }

    endOfMonth(d) {
        d = new Date(d);
        return new Date(d.getFullYear(), d.getMonth() + 1, 0);
    }

    startOfYear(d) {
        d = new Date(d);
        return new Date(d.getFullYear(), 0, 1);
    }

    endOfYear(d) {
        d = new Date(d);
        return new Date(d.getFullYear(), 11, 31);
    }

    startOfWeek(d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    }

    endOfWeek(d) {
        d = this.startOfWeek(d);
        return new Date(d.setDate(d.getDate() + 6));
    }

    formatDate(d) {
        var result = '';
        var day = d.getDate();
        if (day < 10) result += '0';

        result += day + '.';

        var month = d.getMonth() + 1;
        if (month < 10) result += '0';

        result += month + '.' + d.getFullYear();

        return result;
    }

    handlePrev() {
        var currentDate = new Date(this.state.currentDate);
        if (this.props.viewType === -1) {
            currentDate.setDate(currentDate.getDate() - 1);
        }
        else if (this.props.viewType === 0) {
            currentDate.setDate(currentDate.getDate() - 7);
        }
        else if (this.props.viewType === 1) {
            currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        }
        else if (this.props.viewType === 2) {
            currentDate = new Date(currentDate.getFullYear() - 1, 1, 1);
        }

        this.setState({ currentDate: currentDate });
        var newDates = this.getDates(currentDate);
        this.setState(newDates);

        if (this.props.onPeriodChange) {
            this.props.onPeriodChange(newDates);
        }
    }

    handleNext() {
        var currentDate = new Date(this.state.currentDate);
        if (this.props.viewType === -1) {
            currentDate.setDate(currentDate.getDate() + 1);
        }
        else if (this.props.viewType === 0) {
            currentDate.setDate(currentDate.getDate() + 7);
        }
        else if (this.props.viewType === 1) {
            currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
        }
        else if (this.props.viewType === 2) {
            currentDate = new Date(currentDate.getFullYear() + 1, 1, 1);
        }

        this.setState({ currentDate: currentDate });
        var newDates = this.getDates(currentDate);
        this.setState(newDates);

        if (this.props.onPeriodChange) {
            this.props.onPeriodChange(newDates);
        }
    }

    render() {
        return (
            <div>
                <IconButton aria-label="Назад" size="small" onClick={this.handlePrev}>
                    <ArrowLeft fontSize="inherit" />
                </IconButton>
                {this.formatDate(this.state.start)} - {this.formatDate(this.state.end)}
                <IconButton aria-label="Вперед" size="small" onClick={this.handleNext}>
                    <ArrowRight fontSize="inherit" />
                </IconButton>
            </div>);
    }
}